import VueRouter from 'vue-router';

export default new VueRouter({
	// mode: 'history',
	routes: [
		{ path: '/', redirect: '/list' }, //重定向
		{
			path: '/list',
			component(resolve) {
				require(['./views/user/questionnaire.vue'], resolve);
			},
			class: 'icon-zu3',
			name: 'questionnaire',
			navName: '问卷调查',
			meta: {
				title: '映目-调查问卷'
			}
		},
		//用户投票页面
		{
			path: '/questionnaireVote/:id/:handle',
			name: 'questionnaireVote',
			component(resolve) {
				require(['./views/questionnaireVote.vue'], resolve);
			}
		},
		{
			path: '/projectCount/:surveyId/:source',
			name: 'projectCount',
			component(resolve) {
				require(['@/views/questionList/projectCount.vue'], resolve);
			}
		},
		{
			path: '/setQuestionnaire/:id/:handle/:type',
			component(resolve) {
				require(['./views/user/setQuestionnaire.vue'], resolve);
			},
			class: 'icon-setting',
			navName: '调查问卷-编辑与管理',
			name: 'setQuestionnaire',
			hidden: true
		},
		{
			path: '/questionnaireDataStatistics/:id',
			component(resolve) {
				require(['./views/user/questionnaireDataStatistics.vue'], resolve);
			},
			class: 'icon-setting',
			navName: '调查问卷-数据统计',
			name: 'questionnaireDataStatistics',
			hidden: true
		},
		{
			path: '/questionnaireDataStatisticsEdit/:id/:source/:handle/:oldMark',
			component(resolve) {
				require(['./views/user/questionnaireDataStatisticsEdit.vue'], resolve);
			},
			class: 'icon-setting',
			navName: '调查问卷-数据统计-查看编辑',
			name: 'questionnaireDataStatisticsEdit',
			hidden: true
		}
	],
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 };
	},
	base: '/questionnaire/'
});
